import { render, staticRenderFns } from "./artificial.vue?vue&type=template&id=57cb59c5&scoped=true&"
import script from "./artificial.vue?vue&type=script&lang=js&"
export * from "./artificial.vue?vue&type=script&lang=js&"
import style0 from "./artificial.vue?vue&type=style&index=0&id=57cb59c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb59c5",
  null
  
)

export default component.exports